<template>
  <div class="loading-container" v-loading="true"></div>
</template>

<script>
import { loginHioSTB } from "../../api/wap/loginWebView";
import jwt from "jsonwebtoken";
import { SOURCE_BANK } from "@/constant/contant";
import { toggleChat } from "@/utils/helper";

export default {
  created() {
    let token = this.$router?.history?.current?.query?.token || "";
    // console.log("token......", token);
    let user = jwt.decode(token);
    // console.log("user......", user);
    loginHioSTB({
      uid: user.vga,
      cif: user.cif,
      fullname: user?.fullname,
      phone: user.phone,
      order_id: user.orderId,
      merchant: user.merchant,
      bank_id: SOURCE_BANK.SCB,
      lang: localStorage.getItem("language")
    }).then(res => {
      if (res.error_code === 0) {
        let urlRedirect = res.data.url;
        if (["105581", "118027"].includes(user.vga)) {
          window.location.href = urlRedirect;
        } else {
          window.location.href = urlRedirect.replace(
            "https://hio.wghn.net/",
            "https://hio-stb.wghn.net/"
          );
        }
      } else {
        this.$message.error(res.error_msg);
      }
    });
  },
  mounted() {
    toggleChat(false);
  }
};
</script>
<style scoped>
.loading-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
